import React, { useEffect, useState } from "react";

import { Stack } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { resetTokenValidCheck } from "../../../Api/Signin/Signin.Api";
import { Heading } from "../../../Components/atoms/Typography/Heading/Heading";
import { SubHeader4 } from "../../../Components/atoms/Typography/SubHeader/SubHeader";
import { SetPasswordForm } from "../../../Components/molecules/AuthForms/SetPasswordForm";
import Spinner from "../../../Components/molecules/Spinner/Spinner";
import { FormItemsWrap } from "../../../Components/molecules/Wrap/Wrap";
import { useAuth } from "../../../Store/AuthContext";

export const ResetPassword = () => {
  const { t, i18n } = useTranslation(["glossary"]);

  // Admin App: New User - Reset password
  const [stepCount, setStepCount] = useState(1);
  const { state, dispatch } = useAuth();
  const navigate = useNavigate();
  const urlparams = new URLSearchParams(useLocation().search);
  const username = urlparams.get('email');
  const expireTime = urlparams.get('expiretime');
  const lan = urlparams.get("lan");
  const token = decodeURIComponent(urlparams.get('token'));
  const replacedToken = token.replace(/ /g, '+');

  useEffect(() => {
    i18n.changeLanguage(lan);
    dispatch({
      type: "SELECT_LANG",
      payload: lan,
    });
    if (state.lang.cookie && state.lang.code && stepCount === undefined) {
      setStepCount(1);
    } else if (!state.lang.cookie && stepCount === undefined) {
      const code = document.cookie
        .split(" ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1];
      if (code) {
        dispatch({
          type: "SET_LANG_FROM_COOKIE",
          payload: code,
        });

        i18n.changeLanguage(code);
        setStepCount(1);
      } else {
        setStepCount(0);
      }
    }
    dispatch({
      type: "LOADING",
      payload: false,
    });
  }, [state.lang, stepCount]);


  useEffect(() => {

    const validityTimer = setTimeout(() => {
      CheckValidity()
    }, 500);

    return () => {
      clearTimeout(validityTimer);
    };
  }, [])

  const CheckValidity = async (e) => {
    try {
      setStepCount(1);
      await resetTokenValidCheck({
        emailAddress: username,
        token: replacedToken,
      })
        .then((d) => {
          setStepCount(0);
          if (d.message == "used") {
            navigate('/contact-support', {
              state: {
                lan: lan
              }
            })
          }

        })
        .catch((e) => console.log(e));
    } catch (error) {
      console.log("error", error);
    }
  };


  const steps = [
    {
      title: t("glossary:auth.reset-password.title"),
      subheading: t("glossary:auth.reset-password.subheading"),
      component: (
        <SetPasswordForm
          t={t}
          type={"reset"}
          token={token}
          username={username}
          expireTime={expireTime}
          state={state}
          onClick={(status, password) => {
            if (status === "pass") {
              navigate("/signin/reset-password-message", {
                state:
                {
                  message:
                  {
                    messageLineOne: t("glossary:auth.reset-password.reset-link"),
                    messageLineTwo: t("glossary:auth.reset-password.successfully"),
                    buttonInputMessage: t("common:button.login"),
                    username: username,
                    password: password,
                  }
                }
              })
            }else if(status == "link-expired"){
              navigate('/contact-support', {
                state: {
                  lan: lan
                }
              })
            }
          }}
        />
      ),
    }, {
      component: (
        <Spinner />
      ),
    },
  ];

  return (
    <Stack
      style={{
        padding: steps[stepCount]?.padding || "38px",
      }}
    >
      <FormItemsWrap
        gap={"32px"}
        width={"398px"}
        alignItems={steps[stepCount]?.alignItems}
        justifyContent={"space-around"}
      >
        {!steps[stepCount]?.isNoHeading && (
          <FormItemsWrap>
            <Heading text={steps[stepCount]?.title} />
            <SubHeader4 text={steps[stepCount]?.subheading} />
          </FormItemsWrap>
        )}
        {steps[stepCount]?.component}
      </FormItemsWrap>
    </Stack>
  );
};
